import {SuperObjectModel} from "./super-object-model";
import {StateParams} from "./state-params";

export class RefParams {
  object: SuperObjectModel;
  stateParams: StateParams;
  rootObjId: string;
  rootObjType: string;
  searchItemIndex: number;
  edit: boolean;
  isNew: boolean;

  constructor(object: SuperObjectModel, stateParams?: StateParams) {
    this.object = object;
    this.stateParams = stateParams;
  }
}
